import * as React from 'react'
import styled from 'styled-components'

import { t } from '@owl-nest/localize'
import { styles as S, Button } from '@ulule/owl-kit-components/next'

import { useListLoadingIndicator } from '../../hooks/useListLoadingIndicator'
import { State as CommentState } from '../../../../../reducers/comments'
import { CommentNode } from '../../components/Comments/CommentNode'

type CommentListProps = {
  list: Exclude<CommentState['list']['root'], undefined>
  onLoadMore: (next: string) => void
}

export function CommentList({ list, onLoadMore }: CommentListProps): React.ReactElement<CommentListProps> {
  const hasMore = list.next !== null && list.size > list.comments.length
  const [isLoading, markLoadingStart] = useListLoadingIndicator(list.comments.length)

  return (
    <>
      {list.newComments.map((comment) => (
        <CommentNode key={comment.id} comment={comment} parentId="root" />
      ))}
      {list.comments.map((comment) => (
        <CommentNode key={comment.id} comment={comment} parentId="root" />
      ))}
      {hasMore && (
        <SeeMoreWrapper>
          <Button
            kind="secondary"
            loading={isLoading}
            onClick={() => {
              if (list.next) {
                onLoadMore(list.next)
                markLoadingStart()
              }
            }}
          >
            {t('See more')}
          </Button>
        </SeeMoreWrapper>
      )}
    </>
  )
}

const SeeMoreWrapper = styled.div`
  display: flex;
  justify-content: center;

  ${S.button.Button} {
    margin: 48px 0;
  }
`
